import { render, staticRenderFns } from "./ProfilepagePage.vue?vue&type=template&id=49ac7928"
import script from "./ProfilepagePage.vue?vue&type=script&lang=js"
export * from "./ProfilepagePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports